import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {UnstyledButton} from '../Buttons/UnstyledButton';

export const SliderProgressBar: React.FC<{
  durationInMs: number;
  active: boolean;
  done: boolean;
  datatestId?: string;
  onClick: VoidFunction;
  paused?: boolean;
}> = ({
  active,
  done,
  durationInMs,
  datatestId = 'progressBar',
  onClick,
  paused,
}) => (
  <BarContainer
    onClick={onClick}
    tabIndex={-1}
    aria-hidden="true"
    aria-label={undefined}
  >
    <Bar
      $durationInMs={durationInMs}
      data-active={active}
      data-done={done}
      data-testid={datatestId}
      data-paused={paused}
    />
  </BarContainer>
);

export const ProgressBarContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 0.5rem;
  justify-content: center;
`;

const BarContainer = styled(UnstyledButton)`
  flex: 1;
  max-width: 3rem;
  padding: 8px 0;
  margin: -8px 0;
  background: none;
  border: none;
`;

const Bar = styled.div<{
  $durationInMs: number;
}>`
  position: relative;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.4);

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    margin: auto;
    height: 3px;
    transform: scaleX(0);
    transform-origin: left;
    background-color: ${COLORS.White};
  }

  &[data-done='true']::after {
    transform: scaleX(1);
  }

  &[data-active='true']::after {
    transform: scaleX(1);
    animation: enlarge ${({$durationInMs}) => $durationInMs}ms linear;
  }
  &[data-paused='true']::after {
    animation-play-state: paused;
  }

  @keyframes enlarge {
    0% {
      transform: scaleX(0);
    }
    100% {
      transform: scaleX(1);
    }
  }
`;
